import { render, staticRenderFns } from "./GoodsName.vue?vue&type=template&id=38748a9b&scoped=true&"
import script from "./GoodsName.vue?vue&type=script&lang=js&"
export * from "./GoodsName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38748a9b",
  null
  
)

component.options.__file = "GoodsName.vue"
export default component.exports